// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderBy_wrapper__1Lb1c","tri":"OrderBy_tri__2etcp","select":"OrderBy_select__19rDs"};